import { JwtPayload, jwtDecode } from 'jwt-decode';
import { getStorage } from './local-store';
import { LS_KEYS } from '@constants/local-store';

type TokenDecodeType = {
  userType: number | null;
  constituencyId: number | null;
};

export const jwtDecodeHandler = (): TokenDecodeType => {
  const token = getStorage(LS_KEYS.AUTH_TOKEN);

  try {
    const decoded: any = jwtDecode<JwtPayload>(token || '');

    return {
      userType: decoded[`user-type`] || null,
      constituencyId: decoded[`constituency-id`] || null,
    };
  } catch (err) {
    return {
      userType: null,
      constituencyId: null,
    };
  }
};

export const getAccess = (id?: number | undefined | null) => {
  const access: TokenDecodeType = jwtDecodeHandler();

  if (access.userType === 1) {
    return true;
  } else if (access.userType === 2) {
    if (access.constituencyId === id) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
